module.exports = __webpack_public_path__ + "img/robuste@2x.76fca05d.png";